<template>
  <div id="user">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb
            :link="[{ name: 'Quản lý nhân viên', active: true }]"
          ></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="buser" class="soft-control">
        <control-panel
          :countChecked="countChecked"
          @doAddNew="handleCreate"
          @doEdit="handleUpdate"
          @search="handleSearch"
          @copy="handleCopy"
          :help="handleHelp"
          @doDelete="handleDelete"
          :permission="{
            create: 'user_create',
            edit: 'user_edit',
            print: 'user_print',
            export: 'user_export',
            delete: 'user_delete'
          }"
        ></control-panel>
        <div class="row p-1">
          <div class="col-md-12">
            <soft-table
              @rowSelected="tbSetRowSelected"
              @rowClicked="tbRowClicked"
              @doDeleteRow="handleDelete"
              @doEditRow="handleUpdate"
              class="table align-items-center table-flush"
              tbody-classes="list"
              :pending="false"
              :dataTable="tableData"
              :fields="fields"
              :minHeight="$hMainContent - 64"
              :contextMenus="[
                {
                  key: 'permission',
                  icon: 'fa-cog',
                  label: 'Phân quyền'
                },
                {
                  key: 'resetpass',
                  icon: 'fa-sync-alt',
                  label: 'Khôi phục mật khẩu'
                }
              ]"
              :permission="{
                edit: 'user_edit',
                delete: 'user_delete'
              }"
              @contextMenuItemClick="tbHandleContextMenuItemClick"
              ref="soft-table"
            >
              <template v-slot:cell(isBlock)="{ item }">
                <span
                  @click="handleBlock(item)"
                  v-if="!item.isBlock"
                  class="badge badge-danger"
                  >Vô hiệu hoá</span
                >
                <span
                  v-else
                  @click="handleUnBlock(item)"
                  class="badge badge-success"
                  >Kích hoạt</span
                >
              </template>
              <template v-slot:cell(role)="{ value }">
                <span class="badge badge-warning">{{ value.name }}</span>
              </template>
              <template v-slot:cell(userCreate)="{ value }">
                <span v-if="value.id" class="badge badge-primary">
                  {{ value.username }}
                </span>
              </template>
              <template v-slot:cell(userVerify)="{ value }">
                <span v-if="value.id" class="badge badge-success">
                  {{ value.username }}
                </span>
                <span v-else class="badge badge-danger">Chưa được duyệt</span>
              </template>
              <template v-slot:cell(userManage)="{ value }">
                <span v-if="value.id" class="badge badge-info">
                  {{ value.username }}
                </span>
                <span v-else class="badge badge-danger"
                  >Chưa có người hỗ trợ</span
                >
              </template>
              <template v-slot:action="{ item }">
                <b-button
                  v-if="$permission('user_reset-password')"
                  @click="tbRowResetPassword(item)"
                  variant="primary px-1 py-0"
                  >Khôi phục mật khẩu</b-button
                >
                <b-button
                  v-if="$permission('user_update-role')"
                  @click="tbRowChangePermission(item)"
                  variant="info px-1 py-0"
                  >Cập nhật quyền</b-button
                >
              </template>
              <template>
                <pagination
                  class="mr-2 my-1"
                  slot="footer"
                  :total="listQuery.total"
                  :perPage="listQuery.limit"
                  @change="pagChange"
                />
              </template>
            </soft-table>
          </div>
        </div>
      </block>
    </div>
    <user-modal @submit:success="fetchData" ref="userModal"></user-modal>
    <permission-modal ref="permissionModal"></permission-modal>
    <event @doAdd="handleCreate" @doEdit="handleUpdate"></event>
  </div>
</template>
<script>
import UserModal from "./__UserModal";
import PermissionModal from "./__PermissionModal";
import { userService } from "@/_services";
export default {
  name: "user-manage",
  components: {
    UserModal,
    PermissionModal
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 10,
        total: 0
      },
      lastIndexCustomerSelected: 0,
      info: {},
      tableData: [],
      tableDataSelecteds: [],
      fields: [
        {
          variant: "primary",
          key: "id",
          class: "checkbox"
        },
        {
          stickyColumn: true,
          key: "name",
          label: "Tên nhân viên",
          sortable: true
        },
        {
          tdClass: "text-center",
          key: "username",
          label: "Tài khoản",
          sortable: true
        },
        {
          tdClass: "text-center",
          key: "phone",
          label: "Số điện thoại",
          sortable: true
        },
        {
          key: "email",
          label: "Email",
          sortable: true
        },
        {
          tdClass: "text-center",
          key: "role",
          label: "Quyền",
          sortable: true
        },
        {
          tdClass: "text-center",
          key: "isBlock",
          label: "Trạng thái",
          sortable: true
        },
        {
          tdClass: "text-center",
          key: "action",
          label: ""
        }
      ]
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$refs.buser.block();
      userService
        .list(this.listQuery)
        .then(res => {
          this.tableData = res.data.data;
          this.listQuery.total = res.data.total;
          this.$refs["soft-table"].selectRow(this.lastIndexCustomerSelected);
        })
        .finally(() => {
          this.$refs.buser.unBlock();
        });
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log("context menu", a);
      if (a.menu.key == "permission") {
        this.tbRowChangePermission(a.data);
      } else if (a.menu.key == "resetpass") {
        this.tbRowResetPassword(a.data);
      }
    },
    handleUpdate() {
      this.$refs.userModal.visible = true;
      this.$refs.userModal.setData(this.info);
    },
    handleCreate() {
      this.$refs.userModal.setData({ username: "", email: "" });
      this.$refs.userModal.visible = true;
    },
    handleCopy() {
      let newItem = Object.assign({}, this.info);
      delete newItem.id;
      this.$refs.userModal.setData(newItem);
      this.$refs.userModal.visible = true;
    },
    handleHelp() {
      alert("help");
    },
    handleDelete() {
      if (this.countChecked == 0) return;
      let listRemove = [];
      this.tableDataSelecteds.forEach(element => {
        listRemove.push(element.id);
      });
      this.$refs.buser.block();
      userService
        .removeList(listRemove)
        .then(() => {
          this.lastIndexCustomerSelected = 0;
          this.fetchData();
        })
        .finally(() => {
          this.$refs.buser.unBlock();
        });
    },
    tbSetRowSelected(items) {
      this.tableDataSelecteds = items;
      this.countChecked = items.length;
    },
    tbRowResetPassword(item) {
      var self = this;
      this.$swal({
        title: "Bạn có chắc sẽ khôi phục mật khẩu cho tài khoản này",
        text: "Khôi phục mật khẩu",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Không",
        reverseButtons: true
      }).then(function(result) {
        if (result.value) {
          self.$refs.buser.block();
          userService
            .resetPassword(item.id)
            .then(res => {
              self.$alertify.success(res.message, {
                duration: 4000
              });
            })
            .finally(() => {
              self.$refs.buser.unBlock();
            });
        }
      });
    },
    tbRowChangePermission(item) {
      this.$refs.permissionModal.visible = true;
      this.$refs.permissionModal.setData(item);
    },
    resize() {
      this.hMainScreen = window.innerHeight - 292;
      if (this.hMainScreen < 831) this.hMainScreen = 831;
      this.hMainContent = (this.hMainScreen * 65) / 100;
      this.hMainTable = this.hMainContent - 64;
      this.hSecondaryContent = this.hMainScreen - this.hMainContent;
    }
  }
};
</script>
<style lang="scss"></style>
